import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom"; // Import useLocation for route detection
import { FaUser, FaSignOutAlt } from "react-icons/fa";
import leapLogo from "../assets/images/leap-logo.svg";
import Button from "../components/Button";
import Modal from "../components/Modal";
import Login from "./Login";
import { useAuth } from "../contexts/AuthContext";

function Navbar() {
  const [imdodalOpen, setImdodalOpen] = useState(false); // Modal visibility state
  const navigate = useNavigate();
  const location = useLocation(); // Get the current route
  const { loggedIn, logout } = useAuth();

  const openModal = () => setImdodalOpen(true); // Function to open the modal
  const closeModal = () => setImdodalOpen(false); // Function to close the modal

  // Logout function
  const handleLogout = () => {
    logout();
    navigate("/"); // Optionally navigate to home or login page after logout
  };

  return (
    <nav className="leap-bg-black xl:leap-bg-transparent leap-absolute leap-z-50 leap-py-4 xl:leap-p-7  leap-right-0 leap-left-0">
      <div className="leap-flex leap-justify-between leap-items-center leap-mx-3">
        <Link to={"/"} className="leap-text-white">
          <img
            src={leapLogo}
            alt="logo"
            className="leap-w-24 md:leap-w-32 xl:leap-min-w-56"
            loading="lazy"
          />
        </Link>

        <div className="leap-flex leap-gap-4 leap-items-center">
          {!loggedIn ? (
            <div className="leap-flex leap-items-center leap-gap-2  xl:leap-gap-3 2xl:leap-gap-4">
              {/* login btn*/}
              <Button
                text="Login"
                bgColor="white"
                textColor="black"
                customStyles="leap-shadow-2xl leap-hidden xl:leap-block leap-min-w-[110px] leap-min-w-[150px] leap-min-h-10 leap-min-h-12 xl:leap-min-h-[56px] 2xl:leap-min-w-[217px] leap-text-xs xl:leap-text-md xl:leap-text-xl"
                onClick={openModal}
              />

              <button
                onClick={openModal}
                className="leap-text-white leap-p-2 leap-mx-2 leap-rounded-xl leap-bg-white leap-shadow-xl leap-text-2xl leap-flex leap-items-center leap-justify-center leap-w-7 leap-h-7  xl:leap-hidden"
              >
                <FaUser className="leap-text-black" />
              </button>

              {/* Still Not logged in */}
              <Button
                text="Reserve Tour"
                bgColor="linear-gradient(270deg,#EB3DF7 0%,#3B29AB 92.17%)"
                textColor="white"
                customStyles="!leap-min-w-[100px] leap-rounded-xl !leap-min-h-8  xl:!leap-min-h-[56px] xl:!leap-min-w-[217px] leap-text-xs xl:leap-text-md xl:leap-text-xl"
                onClick={() => navigate("/reservation")}
              />
            </div>
          ) : (
            <div className="leap-flex leap-items-center leap-gap-1">
              {/* logout btn*/}
              <Button
                text="Logout"
                bgColor="white"
                textColor="black"
                customStyles="leap-shadow-2xl leap-hidden xl:leap-block leap-min-w-[110px] leap-min-w-[150px] leap-min-h-10 leap-min-h-12 xl:leap-min-h-[56px] 2xl:leap-min-w-[217px] leap-text-xs xl:leap-text-md xl:leap-text-xl"
                onClick={handleLogout}
              />

              <button
                onClick={handleLogout}
                className="leap-text-white leap-p-2 leap-mx-2 leap-rounded-xl leap-bg-white leap-shadow-xl leap-text-2xl leap-flex leap-items-center leap-justify-center leap-w-7 leap-h-7  xl:leap-hidden"
              >
                <FaSignOutAlt className="leap-text-black" />
              </button>

              {/* Conditional Button for /verification */}
              {location.pathname === "/verification" ? (
                <Button
                  text="Booked Tours"
                  bgColor="linear-gradient(270deg,#EB3DF7 0%,#3B29AB 92.17%)"
                  textColor="white"
                  customStyles="xl:leap-ml-2 !leap-min-w-[100px] leap-rounded-xl !leap-min-h-8  xl:!leap-min-h-[56px] xl:!leap-min-w-[217px] leap-text-xs xl:leap-text-md xl:leap-text-xl"
                  onClick={() => navigate("/personal-page")}
                />
              ) : (
                // After login
                <Button
                  text="Reserve Tour"
                  bgColor="linear-gradient(270deg,#EB3DF7 0%,#3B29AB 92.17%)"
                  textColor="white"
                  customStyles="xl:leap-ml-2 !leap-min-w-[100px] leap-rounded-xl !leap-min-h-8  xl:!leap-min-h-[56px] xl:!leap-min-w-[217px] leap-text-xs xl:leap-text-md xl:leap-text-xl"
                  onClick={() =>
                    navigate("/verification", { state: { status: true } })
                  }
                />
              )}
            </div>
          )}
        </div>
      </div>

      <Modal isOpen={imdodalOpen} closeModal={closeModal}>
        <Login onClick={closeModal} />
      </Modal>
    </nav>
  );
}

export default Navbar;
